import { Component, signal, ChangeDetectionStrategy } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { FilledButtonComponent, OutlinedButtonComponent } from '@custom-components/general/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { SpinnerComponent } from '@custom-components/general/spinner/spinner.component';
import { SkeletonBlockComponent } from '@custom-components/general/skeleton/skeleton-block/skeleton-block.component';
import { NoItemsFoundComponent } from '@custom-components/general/no-items-found/no-items-found.component';
import { StatusChipComponent } from '@custom-components/general/status-chip/status-chip.component';

interface Section {
  id: string;
  label: string;
}

@Component({
  selector: 'xemex-component-library-page',
  standalone: true,
  imports: [
    MatButtonModule,
    FilledButtonComponent,
    OutlinedButtonComponent,
    MatIconModule,
    MatDividerModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    SpinnerComponent,
    SkeletonBlockComponent,
    NoItemsFoundComponent,
    StatusChipComponent,
  ],
  templateUrl: './component-library-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './component-library-page.component.scss',
})
export class ComponentLibraryPageComponent {
  activeSection = signal('colors');

  sections: Section[] = [
    { id: 'colors', label: 'Colors & Tokens' },
    { id: 'typography', label: 'Typography' },
    { id: 'buttons', label: 'Buttons' },
    { id: 'status', label: 'Status Badges' },
    { id: 'surfaces', label: 'Surfaces & Borders' },
    { id: 'spinner', label: 'Spinner' },
    { id: 'skeleton', label: 'Skeleton' },
    { id: 'no-items', label: 'No Items Found' },
    { id: 'forms', label: 'Form Elements' },
    { id: 'dialog-shell', label: 'Dialog Shell' },
  ];

  colorTokens = [
    { name: '--primary_main', label: 'Primary', tailwind: 'bg-primary', hex: '#16A085' },
    { name: '--secondary_main', label: 'Secondary', tailwind: 'bg-secondary', hex: '#F36F22' },
    { name: '--tertiary', label: 'Tertiary (surface)', tailwind: 'bg-tertiary', hex: '#F4F4F4' },
    { name: '--neutral', label: 'Neutral (labels)', tailwind: 'bg-neutral', hex: '#8080A5' },
    { name: '--crimson', label: 'Crimson (error)', tailwind: 'bg-crimson', hex: '#D50000' },
  ];

  inconsistentSurfaces = [
    '#f5f5f5',
    '#f5f5fa',
    '#f8f9fa',
    '#F5F5FA',
    '#FBFBFB',
    '#fafafa',
    '#F6F6F6',
    '#F5F8FA',
  ];

  inconsistentBorders = ['#ECECF2', '#E5E5E5', '#F5F5F5', '#e1e7ee', '#e0e0e0'];

  scrollTo(id: string) {
    this.activeSection.set(id);
    document.getElementById('section-' + id)?.scrollIntoView({ behavior: 'smooth' });
  }
}
